import JointAccountOwnerApiClient from "@/api/jointAccountOwnerApiClient";
import { AppToasterV2 } from "@ucl/library";
import { useEffect, useState } from "react";
import { useAuthenticatedApiClient } from "./useAuthenticatedApiClient";
import { JointAccountOwner } from "@/types";

export const useJointAccountOwnersSummary = (financialApplicationId: string) => {
  const [jointAccountOwners, setJointAccountOwners] = useState<JointAccountOwner[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const jointAccountOwnerApiClient = useAuthenticatedApiClient(JointAccountOwnerApiClient);

  useEffect(() => {
    getJointAccountOwners();
  }, [financialApplicationId]);

  const getJointAccountOwners = async () => {
    setIsLoading(true);
    try {
      const owners = await jointAccountOwnerApiClient.getJointAccountOwners(financialApplicationId);
      setJointAccountOwners(owners);
    } catch (error) {
      console.error(error);
      AppToasterV2.showFailedActionToaster("Failed to get joint account owners.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    jointAccountOwners,
    isLoading,
    getJointAccountOwners,
  };
};
